import NewsletterSection from '@/components/NewsletterSection'
import BlogCard from '@/components/BlogCard'
import { getVision, getLatestBlogs } from '@/lib/api'
import BlueHero from '@/components/BlueHero'

export default async function AboutVision() {
  const [data, blogs] = await Promise.all([getVision(), getLatestBlogs()])
  const visionItems = data?.core_values || []
  const goals = data?.goals || []
  const latestBlogs = blogs?.slice(0, 3) || []

  return (
    <>
      <BlueHero title="MR. ALRIFAI VISION" />

      {/* Vision content */}
      <section style={{ background: '#07090e', padding: '72px 0' }}>
        <div style={{ maxWidth: '820px', margin: '0 auto', padding: '0 40px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 900, color: '#fff', letterSpacing: '0.08em', marginBottom: '20px' }}>SHAPING A FUTURE OF INNOVATION.</h2>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.60)', lineHeight: 1.95, marginBottom: '48px' }}>
            {data?.vision?.description || "Ghassan's Vision Is All About Empowering Entrepreneurs And Creating A Lively Environment Of Innovation And Growth. He Believes In The Power Of Collaboration And Mutual Success, Aiming To Build Win-Win Partnerships And Foster Relationships That Drive Collective Growth."}
          </p>
          {/* Staggered items from API */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
            {(visionItems.length > 0 ? visionItems : [
              { id: 1, icon: '', title: 'Driving Collective Growth' },
              { id: 2, icon: '', title: 'Building Collaborative Partnerships' },
              { id: 3, icon: '', title: 'Empowering Entrepreneurs' },
            ]).map((item, i) => (
              <div key={item.id} style={{ marginLeft: `${i * 120}px`, marginBottom: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: 700, color: '#f97316', marginBottom: '3px' }}>#{i + 1}</div>
                <div style={{ display: 'inline-block', fontSize: '13.5px', color: '#fff', fontWeight: 500, borderBottom: '1px solid rgba(255,255,255,0.25)', paddingBottom: '2px' }}>{item.title}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HIS GOALS */}
      <section style={{ background: '#0c0f1c', padding: '64px 0' }}>
        <div style={{ maxWidth: '820px', margin: '0 auto', padding: '0 40px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 900, color: '#f97316', letterSpacing: '0.10em', marginBottom: '20px' }}>HIS GOALS</h2>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.60)', lineHeight: 1.95 }}>
            {goals[0]?.description || 'We Aim To Be The Pioneers Of Change, Leading Our Industry Towards A More Sustainable And Innovative Future. By Leveraging Cutting-Edge Technology, Fostering A Culture Of Continuous Improvement, And Always Putting Our Clients First, We Will Achieve Unparalleled Success And Make A Lasting Impact On The World'}
          </p>
        </div>
      </section>

      {/* Blog */}
      <section className="relative overflow-hidden" style={{ background: '#161920', padding: '64px 0' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'url(/arab-pattern-bg.jpg)', backgroundSize: 'cover', opacity: 0.07, zIndex: 0 }} />
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'rgba(16,18,26,0.80)', zIndex: 0 }} />
        <div className="relative z-10" style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '10px' }}>From His Blog</h2>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.48)', textAlign: 'center', lineHeight: 1.85, maxWidth: '520px', margin: '0 auto 40px' }}>Dive Into The Blog For The Latest Updates, Expert Opinions, And Detailed Information On Our Projects.</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '18px' }}>
            {(latestBlogs.length > 0 ? latestBlogs : [
              { id: '1', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-homs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '2', title: 'Fly High With Our Exclusive Travel Tips', image: '/blog-steve-jobs.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
              { id: '3', title: 'Fly High With Our Exclusive Travel Tips', image: '/investment-wealth.jpg', date: '24/08/2024', category: 'Travel', likes: 23, comments: 5 },
            ]).map((p: any) => (
              <BlogCard key={p.id} id={String(p.id)} title={p.title} image={p.image} date={p.created_at || p.date} category={p.category || ''} likes={p.likes_count ?? p.likes ?? 0} comments={p.comments_count ?? p.comments ?? 0} />
            ))}
          </div>
        </div>
      </section>
      <NewsletterSection />
    </>
  )
}
